import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Form, Col, Button, Row } from "react-bootstrap";
import MemberLocationDropdown from "../../../components/form/MemberLocationDropdown";
import { ShowFilterRadioGroup } from "./components/ShowFilterRadioGroup";
import { PayerSetupStatusRadioGroup } from "./components/PayerSetupStatusRadioGroup";

import FormValidation from "../../../components/form/validation/FormValidation";
import { UserContext } from "shared/context/UserContext";

export function CurrentAgingForm(props) {
  const [reportType, setReportType] = useState("unreconciled");
  const [dateType, setDateType] = useState("dispense");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const userContext = useContext(UserContext);

  useEffect(() => {
    setLoaded(false);
  }, [
    userContext.locations,
    userContext.metricLocations,
    userContext.recLocations,
    userContext.isUnrestrictedEraPath,
  ]);

  useEffect(() => {
    if (!loaded && selectedLocations.length > 0) {
      setLoaded(true);
      submitForm();
    }
  }, [selectedLocations]);

  function handleFormSubmit(event) {
    event.preventDefault();
    submitForm();
  }

  function submitForm() {
    let parameters = {
      selectedLocations: selectedLocations,
    };

    let validationIssueMessage = FormValidation(parameters);

    if (validationIssueMessage) {
      alert(validationIssueMessage);
    } else {
      props.handleFormSubmit({
        reportType: reportType,
        dateType: dateType,
        mmid: selectedLocations.join(","),
        showPayerType: props.showFilter,
        payerSetupStatus: props.payerSetupStatusFilter,
      });
    }
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      <Row className="justify-content-start">
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Location (NCPDP)</Form.Label>
          <Form.Control
            as={MemberLocationDropdown}
            onChange={(locations) => setSelectedLocations(locations)}
            programSubscription={"Rec2.0"}
          />
        </Col>

        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Date Type</Form.Label>
          <div key="DateType" className="mb-3 mr-2">
            <Form.Check
              custom="true"
              type="radio"
              id="DateTypeCA-1"
              name="DateType"
              label="Dispense date"
              value="dispense"
              onChange={(event) => setDateType(event.target.value)}
              defaultChecked
            />
            <Form.Check
              custom="true"
              type="radio"
              id="DateTypeCA-2"
              name="DateType"
              label="Transaction date"
              value="transaction"
              onChange={(event) => setDateType(event.target.value)}
            />
          </div>
        </Col>

        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Payer Type Filter</Form.Label>
          <ShowFilterRadioGroup
            value={props.showFilter}
            onChange={props.onShowFilterChange}
            name="CurrentAgingShowFilter"
          />
        </Col>

        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Payer Setup Status Filter</Form.Label>
          <PayerSetupStatusRadioGroup
            value={props.payerSetupStatusFilter}
            onChange={props.onPayerSetupStatusFilterChange}
            name="CurrentAgingPayerSetupStatusFilter"
          />
        </Col>

        <Col md="auto" className="d-flex flex-column">
          <Button className="inline-show-result-button" size="sm" type="submit">
            Show Results
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

CurrentAgingForm.propTypes = {
  handleFormSubmit: PropTypes.func.isRequired,
  showFilter: PropTypes.string.isRequired,
  onShowFilterChange: PropTypes.func.isRequired,
  payerSetupStatusFilter: PropTypes.string.isRequired,
  onPayerSetupStatusFilterChange: PropTypes.func.isRequired,
};
